import { jsx as _jsx } from "react/jsx-runtime";
import { BudgetApproval } from '@src/components/Manager/BudgetApproval';
import { PaymentRequestApproval } from '@src/components/Manager/PaymentRequestApproval';
import { ProgramApproval } from '@src/components/Manager/ProgramApproval';
import { useApprovals } from '@src/hooks/useApprovals';
import { useAuth } from '@src/hooks/useAuth';
import { WorkflowType } from '@src/types';
export const ApprovalItem = ({ id }) => {
    const { currentUser } = useAuth();
    const { approvals } = useApprovals({ id, clientId: currentUser?.clientId });
    const approval = approvals[0];
    if (!approval)
        return null;
    if (approval.workflowType === WorkflowType.PROGRAM_APPROVAL ||
        approval.workflowType === WorkflowType.OTHER_SCHOOL_APPROVAL) {
        return _jsx(ProgramApproval, { approval: approval });
    }
    else if (approval.workflowType === WorkflowType.PAYMENT_REQUEST_APPROVAL ||
        approval.workflowType === WorkflowType.PREIMBURSEMENT_APPROVAL) {
        return _jsx(PaymentRequestApproval, { approval: approval });
    }
    else if (approval.workflowType === WorkflowType.BUDGET_APPROVAL) {
        return _jsx(BudgetApproval, { approval: approval });
    }
    return _jsx("div", { children: "Task" });
};
